import { IonAlert, IonButton, IonButtons, IonContent, IonIcon, IonMenuToggle, IonRefresher, IonRefresherContent, IonToolbar, isPlatform, useIonViewDidEnter, useIonViewDidLeave, useIonViewWillEnter, useIonViewWillLeave } from '@ionic/react';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getConfig } from '../../appConfig';
import Header from '../../components/header';
import { forwardTo, getRouteClassName, getRouteTitleAndItems, isWebConfig } from '../../lib/utils';
import { NormalText, Spacer, Title } from '../common';
import StaticHeader from '../staticHeader';
import './index.css';
import BackButton from '../backButton';
import { withTranslation } from '../../lib/translate';
import { chevronBack } from 'ionicons/icons';
import { ReactComponent as Hamburger } from '../../assets/images/hamburger.svg';
import { BottomNavigationIOS, BottomNavigationAndroid } from '../bottomNavigation';

const defaultHeaderTitle = getConfig().general.clientName;

const Layout = ({
	history,
	children,
	headerTitle,
	showSecondToolbar,
	hideBack,
	color,
	poster,
	blank,
	noPadding,
	contentClassName,
	scrollY,
	backHandler,
	selectCategoryOnScroll,
	navConfig,
	showHamburger,
	headerIconColors,
	withRefresher,
	onRefreshHandler,
	headerWithTitle,
	clientProfile,
	profile,
	title,
	style,
	searchActive,
	onSearchHandler,
	hasSearchIcon,
	disableHeaderLogo,
	onTitleClickHandler,
	showLoginIcon,
	tableData,
	showLogoutButton,
	onSearchInputHandler,
	filtersCount,
	hasFilterIcon,
	auth,
	__
}) => {
	useIonViewWillEnter(() => {
		// eslint-disable-next-line no-console
		console.log('1. WillEnter event fired');
	});
	useIonViewDidEnter(() => {
		// eslint-disable-next-line no-console
		console.log('2. DidEnter event fired');
	});
	useIonViewWillLeave((a, b, c) => {
		// eslint-disable-next-line no-console
		console.log('3. WillLeave event fired', a, b, c);
	});
	useIonViewDidLeave((a, b, c) => {
		// eslint-disable-next-line no-console
		console.log('4. DidLeave event fired', a, b, c);
	});
	const routeClassName = getRouteClassName(history.location.pathname, navConfig);
	const logo = clientProfile.logo_image || '';
	let lightspeedError = tableData?.lightspeed_error || false;


	const tableRoutes =
		history.location.pathname == '/split-bill' ||
		history.location.pathname == '/split-bill-by-amount' ||
		history.location.pathname == '/split-bill-by-items' ||
		history.location.pathname == '/table-overview';


	let menuRoutesData = getConfig().flags.removeSidebar && isWebConfig() && getRouteTitleAndItems(history.location.pathname, navConfig)
	if (history.location.pathname == '/loyalty' && !auth?.loggedIn) {
		menuRoutesData = false
	}
	const routeWithTwoColumns = getConfig().flags.removeSidebar && isWebConfig() && ['/order-summary'].includes(history.location.pathname)
	return (
		<>
			{!profile.is_guest ? (
				<>

					{blank || (getConfig().flags.removeSidebar && isWebConfig() && !routeWithTwoColumns) ?
						<>
							{showHamburger && !isWebConfig() ?
								<IonMenuToggle>

									<IonButton
										className={`menu-back header-blank-btn`}
										button
										clear
									>
										<Hamburger className='ion-color-white' />

									</IonButton></IonMenuToggle>
								:
								<BackButton className={`header-blank-btn ${getConfig().flags.removeSidebar ? 'desktop-back-button' : ''}`} backHandler={backHandler} iconColor={'dark'} />


							}
						</>

						: (
							<>
								{!showSecondToolbar ? (
									<StaticHeader
										hideBack={hideBack}
										backHandler={backHandler}
										showHamburger={showHamburger}
										headerIconColors={headerIconColors}
										headerWithTitle={headerWithTitle}
										title={title}
										onSearchHandler={onSearchHandler}
										searchActive={searchActive}
										hasSearchIcon={hasSearchIcon}
										disableHeaderLogo={disableHeaderLogo}
										onTitleClickHandler={onTitleClickHandler}
										showLoginIcon={showLoginIcon}
										showLogoutButton={showLogoutButton}
										__={__}
										onSearchInputHandler={onSearchInputHandler}
										filtersCount={filtersCount}
										hasFilterIcon={hasFilterIcon}

									/>
								) : (
									<>
										<StaticHeader
											hideBack={hideBack}
											backHandler={backHandler}
											headerIconColors={headerIconColors}
											headerWithTitle={headerWithTitle}
											title={title}
											onSearchHandler={onSearchHandler}
											searchActive={searchActive}
											hasSearchIcon={hasSearchIcon}
											disableHeaderLogo={disableHeaderLogo}
											onTitleClickHandler={onTitleClickHandler}
											showLoginIcon={showLoginIcon}
											showLogoutButton={showLogoutButton}
											__={__}
											onSearchInputHandler={onSearchInputHandler}
										filtersCount={filtersCount}
										hasFilterIcon={hasFilterIcon}



										/>
										<Header title={headerTitle || defaultHeaderTitle} hideBack={hideBack} backHandler={backHandler} />
									</>
								)}
							</>
						)}
				</>
			) : (
				<>
					{!isWebConfig() && (
						<IonToolbar
							color="transparent"
							className="primary-toolbar"
							style={{
								backgroundSize: 'auto 35px',
								backgroundImage: !isWebConfig() && !headerWithTitle ? `url(${logo})` : '',
								backgroundRepeat: 'no-repeat',
								backgroundPosition: 'center',
							}}
						>
							{headerWithTitle && <Title className="centered">{title}</Title>}
						</IonToolbar>
					)}
				</>
			)}
			<IonContent scrollY={scrollY !== undefined ? scrollY : true} color={color || 'white'} id={`${isWebConfig() && getConfig().flags.removeSidebar ? 'ion-page-wrapper' : ''}`} className={`${routeClassName} ${contentClassName ? contentClassName : ''} `} >
				{withRefresher && !isWebConfig() && (
					<IonRefresher pullFactor="0.8" onIonRefresh={(e) => onRefreshHandler(e)} slot="fixed">
						<IonRefresherContent pullingIcon="chevron-down-circle-outline"></IonRefresherContent>
					</IonRefresher>
				)}
				{poster ? <div className={'poster ' + poster} /> : null}
				{isWebConfig() && menuRoutesData &&
					<div className='ion-page-navigation'>
						<Title>{__(menuRoutesData.title)}</Title>
						<Spacer size={2} />
						{menuRoutesData.items.map((item, menuRoutesIndex) => (
							<React.Fragment key={`menu-routes_${menuRoutesIndex}`}>
								<NormalText className={`block pointer ${item.active ? 'primary-color bold' : 'label-color'}`} onClick={() => forwardTo(item.path)}>{__(item.label)}</NormalText>
								<Spacer size={2} />
							</React.Fragment>
						))}

					</div>
				}
				<div style={style} className={`${noPadding ? 'no-padding' : 'ion-padding'} ${routeWithTwoColumns ? 'ion-padding-two-columns' : ''}`} onScroll={routeClassName === 'route-order' ? selectCategoryOnScroll : null}>
					{routeWithTwoColumns &&
						<div className='ion-page-header'>
							<div>
								<IonIcon onClick={() => backHandler()} icon={chevronBack} />
								<Title>{title}</Title>
							</div>
						</div>
					}
					{lightspeedError && tableRoutes && (
						<div className="error-overlay">
							<IonAlert
								isOpen={lightspeedError}
								message={getConfig().billPayOptions.errorMessage || 'An error has occurred'}
								buttons={[
									{
										cssClass: 'primary',
										text: 'OK',
										handler: () => forwardTo('/table-bill-pay'),
									},
								]}
								backdropDismiss={false}
							/>
						</div>
					)}

					{withRefresher && isWebConfig() && (
						<IonRefresher pullFactor="0.8" onIonRefresh={(e) => onRefreshHandler(e)} slot="fixed">
							<IonRefresherContent {...(!isWebConfig() ? { pullingIcon: 'chevron-down-circle-outline' } : {})}></IonRefresherContent>
						</IonRefresher>
					)}
					{children}
				</div>
				{!isWebConfig() && isPlatform('ios') && getConfig().flags.hasBottomNavigation && (![auth.loggedIn ? null : '/loyalty', '/login', '/register', '/reset-password', '/locations'].includes(history?.location?.pathname)) &&
					<BottomNavigationIOS />
				}
			</IonContent>
			{!isWebConfig() && isPlatform('android') && getConfig().flags.hasBottomNavigation && (![auth.loggedIn ? null : '/loyalty', '/login', '/register', '/reset-password', '/locations'].includes(history?.location?.pathname)) &&
				<BottomNavigationAndroid />
			}
		</>
	);
};

function mapStateToProps(state) {
	return {
		navConfig: state.common.navConfig,
		profile: state.profile.profile,
		clientProfile: state.common.clientProfile,
		tableData: state.restaurants.tableData,
		auth: state.profile.auth

	};
}
export default connect(mapStateToProps)(withRouter(withTranslation(Layout)));
